import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-data" }
const _hoisted_2 = { class: "form-group" }

import type { ModuleType, ModulePayloadType } from "@/common/types/module";

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import { baseInput, baseSelect, baseTextEditor } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-module',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
	code: "",
	name: "",
	status: "ACTIVE",
	type: "",
	description: null,
};

const payload = ref<ModulePayloadType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const isValid = ref(false);

const optionsStatus = computed(() => [
	{
		option: t("common.labels.active"),
		value: "ACTIVE",
	},
	{
		option: t("common.labels.inactive"),
		value: "INACTIVE",
	},
]);

function validate() {
	let free = ["description"];

	Object.keys(payload.value).forEach((key) => {
		delete errors.value[key];

		if (
			(payload.value[key] === null ||
				payload.value[key] === "" ||
				payload.value[key] === undefined) &&
			!free.includes(key)
		)
			errors.value[key] = t("error.required");
	});

	isValid.value = Object.keys(errors.value).length === 0;
}

function update(key: keyof typeof payload.value) {
	validate();

	if (props.isPatch) {
		if (payload.value[key] === props.data[key]) return;

		emit("update:data", { [key]: payload.value[key] });
		return;
	}

	emit("update:data", payload.value);

	setTimeout(() => emit("validate", isValid.value), 50);
}

function resumeData() {
	if (!props.data) return;

	const { code, type, name, description, status } = props.data;

	payload.value = {
		...payload.value,
		code,
		type,
		name,
		description,
		status,
	};
}

function maskCode(value: string) {
	return value?.replaceAll(" ", "-")?.toUpperCase();
}

const debouceUpdate = debounce(update, 300);

watch(
	() => props.data,
	() => {
		resumeData();
	},
	{ immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
      value: payload.value.name,
      placeholder: _unref(t)('common.placeholders.name'),
      required: "",
      maxlength: "150",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(debouceUpdate)('name')))
    }, _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
      ]),
      _: 2
    }, [
      (errors.value.name)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.name), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.code,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.code) = $event)),
        value: payload.value.code,
        mask: maskCode,
        required: "",
        maxlength: "50",
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(debouceUpdate)('code')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.code")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.code)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.code), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.type) = $event)),
        value: payload.value.type,
        mask: maskCode,
        required: "",
        maxlength: "50",
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_unref(debouceUpdate)('type')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.type)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.type), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.status,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.status) = $event)),
        value: payload.value.status,
        options: optionsStatus.value,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(debouceUpdate)('status')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.description) = $event)),
      onBlur: _cache[9] || (_cache[9] = ($event: any) => (_unref(debouceUpdate)('description')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("category.labels.description")) + " *", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})